import RequestAccessForm from '@/lib/requestAccess/models/RequestAccessForm';

// todo: move this to config
const siteRequestAccessForm = 'https://app.smartsheet.com/b/form/7088e11ad88d47acbd49b634dd894a6d';
class SiteRequestAccessForm extends RequestAccessForm {
  static emailFieldLabel = 'Email';

  static siteNameFieldLabel = 'Site';

  constructor() {
    super(siteRequestAccessForm);
  }
}

export default SiteRequestAccessForm;
